/**
 * 过户排行
 * @author chenxiaojian 2019-12-04
 * 
 */
import React from 'react';

import { Row, Col, DatePicker, Button } from 'antd';

import PageLayout from '../../ui/PageLayout';

import messager from '../../ui/messager';

import moment from 'moment';    //时间
import http from '../../../axios/http';
import Loading from '../../ui/Loading';

import OrgSelect from '../../ui/OrgSelect';

class TransferSumIndex extends React.Component {

    columns = [{
        title: '排名',
        dataIndex: 'index',
        width: '10%',
    }, {
        title: '名称',
        dataIndex: 'name',
        width: '10%',
    }, {
        title: '数量',
        dataIndex: 'count',
        width: '10%',
    }];

    state = {
        loadData: '',
        queryData: {
            month: moment().format("YYYY-MM"),
        },
        showLoding: false,
        
    };


    //月份查询
    queryMonthStart = (date, dateString) => {
        let { queryData } = this.state;
        queryData.month = dateString;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }
    
    //所属市场查询
    orgSelect = (value) => {
        let queryData = this.state.queryData;
        queryData["orgCode"] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }

    //导出
    download = () => {
        let queryData = this.state.queryData;
        if (queryData.month == null || queryData.month === "") {
            messager.notify("前选择月份！", null, "warning");
            return;
        }
        this.setState({ showLoding: true });
        let fileName = queryData.month + " member ranking.xlsx";
        http.download({
            url: '/applyRanking/downloadApplyRanking',
            data: queryData,
            fileName: fileName,
            success: (res) => {
                this.setState({ showLoding: false });
            }
        });
        messager.notify("只会根据查询的时间段导出已经打印的数据！");
    }


    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={8}>
                                <DatePicker.MonthPicker onChange={this.queryMonthStart} placeholder="月份"
                                    defaultValue={moment().startOf('month')} allowClear={false} />

                                <OrgSelect style={{ width: '200px', marginLeft: '10px' }} 
                                    onChange={this.orgSelect}
                                    allowClear={true}
                                    orgType={4}
                                    lessOneHide={true}
                                    treeDefaultExpandAll={true} />
                            </Col>
                            <Col span={16} style={{ textAlign: "right" }}>
                                <Button type="primary" onClick={this.download}>导出</Button>
                            </Col>
                        </Row>
                    )}
                    rowKey="index"
                    url="/applyRanking/findApplyRankingPage"
                    columns={this.columns}
                    initParams={this.state.queryData}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <Loading visible={this.state.showLoding} message="正在导出，请稍候..." />

            </div>
        )
    }
}

export default TransferSumIndex;